module.exports = __webpack_public_path__ + "static/img/res_4.04e5f4f4.png";